import { render, staticRenderFns } from "./PaginationFooter.vue?vue&type=template&id=95d3566e&"
import script from "./PaginationFooter.vue?vue&type=script&lang=ts&"
export * from "./PaginationFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports